
import { Button, Form } from "react-bootstrap"
import useInputArchivo from "../hooks/useInputArchivo"
import url from "../api/url"
import { Listo, Pendiente } from "../assets/icons"


export default function InputArchivo({ tipo, descripcion }) {

    const { procesarArchivo, cargando, cambiarInput, mostrarInput,
        mostrarOcultar, setMostrarInput, nombreArchivo, completado } = useInputArchivo(tipo)
    const { SERVIDOR } = url()


    const decidirQuemostrar = () => {
        if (cargando) {
            return (
                <div className="d-flex justify-content-center">
                    <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            )
        }

        if (!mostrarInput) {

            return (
                <div className='d-flex justify-content-evenly align-items-center'>
                    <a target='_blank' href={ SERVIDOR+'/archivos/'+ nombreArchivo} rel="noreferrer">Ver archivo</a>
                    |
                    <Button variant="link" onClick={cambiarInput}>Actualizar</Button>
                </div>
            )
        } else {
            return (
                <>
                    <Form.Group controlId="formFileLg" className="d-flex flex-row gap-1">
                        <Form.Control
                            type="file"
                            size="sm"
                            accept="image/png, image/jpg, image/jpeg, .pdf"
                            onChange={(e) => procesarArchivo(e, tipo)}
                        />
                        { mostrarOcultar && (
                            <button type="button" className="btn btn-secondary btn-sm" onClick={ () => setMostrarInput(!mostrarInput)}>
                                Cancelar
                            </button>
                        )}
                    </Form.Group>
                </>
            )
        }
    }


    return (
        <tr>
            <td className='py-3 d-flex flex-row align-items-center gap-2'>
                { completado ? <Listo/> : <Pendiente/> }
                <label>{ descripcion }</label>
            </td>
            <td className='py-3'>
                { decidirQuemostrar() }
            </td>
        </tr>
    )

}
